const carouselData = [
  {
    title: '暑期观影指南：六大平台热门片单一览',
    desc: '炎炎夏日，窝在家看片是最惬意的消遣。我们整理了香蕉视频、红桃视频、91视频等六大平台当前最受欢迎的片单，从动作大片到悬疑剧情，从轻松喜剧到深度纪录片，让你的暑期观影不再迷茫。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20abstract%20summer%20entertainment%20illustration%20with%20coral%20and%20golden%20gradients%2C%20flowing%20cinematic%20visual%20elements%20evoking%20movie%20watching%2C%20soft%20ambient%20light%2C%20minimalist%20composition%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-1-2026&orientation=landscape',
    tag: '编辑精选',
  },
  {
    title: '红桃视频原创系列大盘点：哪些值得追？',
    desc: '红桃视频以原创内容见长，旗下拥有多部高口碑原创系列。我们深度盘点了目前最受欢迎的五部原创作品，从剧情设定到制作水准，帮你判断哪些值得投入时间追更。',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20abstract%20artwork%20with%20warm%20rose%20and%20amber%20tones%2C%20layered%20geometric%20shapes%20representing%20original%20content%20curation%2C%20soft%20gradient%20depth%2C%20editorial%20design%20aesthetic%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-2-2026&orientation=landscape',
    tag: '深度专题',
  },
  {
    title: '高清不缓冲：播放技术哪家强？横向评测',
    desc: '我们在同等网络条件下对蜜桃视频、香蕉视频、樱花视频等平台的播放流畅度进行了横向对比测试，从首帧时间、缓冲频率、画质自适应等维度给出客观评测结果。',
    image: 'https://readdy.ai/api/search-image?query=A%20modern%20abstract%20digital%20composition%20with%20peach%20and%20soft%20golden%20gradients%2C%20smooth%20flowing%20streaming%20technology%20visual%20elements%2C%20clean%20minimalist%20design%2C%20contemporary%20tech%20aesthetic%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-3-2026&orientation=landscape',
    tag: '技术评测',
  },
  {
    title: '从新用户到老司机：91视频社区使用全攻略',
    desc: '91视频的社区功能是很多用户的最爱，但新用户可能不知道如何充分利用。本攻略从账号设置、评分体系、收藏管理到话题参与，手把手教你玩转91社区。',
    image: 'https://readdy.ai/api/search-image?query=A%20warm%20terracotta%20abstract%20illustration%20with%20interconnected%20circular%20design%20elements%20representing%20community%20and%20social%20interaction%2C%20soft%20gradient%20background%2C%20modern%20minimalist%20style%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-4-2026&orientation=landscape',
    tag: '使用攻略',
  },
  {
    title: '冷门但优质：樱桃视频与糖豆视频深度体验',
    desc: '除了头部平台，樱桃视频和糖豆视频这类小而美的平台也有独特的价值。我们花了整整一周时间深度体验，为你揭示这些小众平台的隐藏亮点和不足之处。',
    image: 'https://readdy.ai/api/search-image?query=A%20delicate%20abstract%20digital%20artwork%20with%20soft%20pink%20and%20warm%20cream%20gradients%2C%20minimalist%20geometric%20shapes%20evoking%20hidden%20gems%20and%20discovery%2C%20refined%20composition%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-5-2026&orientation=landscape',
    tag: '小众推荐',
  },
  {
    title: '2026上半年影视平台行业趋势回顾与展望',
    desc: '回顾2026年上半年，影视平台行业经历了哪些变化？新平台涌现、技术升级、内容多元化趋势明显。我们梳理了六大关键变化，并展望下半年的发展方向。',
    image: 'https://readdy.ai/api/search-image?query=A%20sophisticated%20abstract%20illustration%20with%20warm%20coral%20and%20golden%20amber%20gradients%2C%20flowing%20upward%20trend%20visual%20elements%20representing%20industry%20growth%2C%20modern%20editorial%20design%2C%20clean%20composition%2C%20no%20text%20no%20people&width=600&height=400&seq=carousel-6-2026&orientation=landscape',
    tag: '行业趋势',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="bg-background-50 section-padding">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            深度内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            编辑团队精心策划的深度专题内容，全方位解读影视平台行业动态与使用指南
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselData.map((item, idx) => (
            <article
              key={idx}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[3/2] bg-background-100 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-[10px] font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1 line-clamp-3">
                  {item.desc}
                </p>
                <div className="mt-4 pt-3 border-t border-background-100 flex items-center justify-between">
                  <span className="text-xs text-foreground-400">专题文章</span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1">
                    阅读全文
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}